import { Item, ItemContent, ItemHeader, ItemTitle } from '@ibsys/kit';
import { IconButton } from '@/shared/ui';
import { TrashIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import type { KnowledgeNodeInSet } from '@/entities/knowledge-set';

type Props = {
  node: KnowledgeNodeInSet;
  onRemove: (nodeId: number) => void;
  readonly?: boolean;
};

/** Строка списка выбранных узлов сета: одинакова для сохранённого состава и для ещё не сохранённых добавлений */
export const SelectedNodeItem: FC<Props> = ({ node, onRemove, readonly }) => {
  const { t } = useTranslation('knowledgeSets');

  return (
    <li>
      <Item variant="outline" size="sm">
        <ItemHeader className="flex items-center justify-between">
          <div className="flex flex-col gap-1 min-w-0 flex-1">
            <ItemTitle className="text-sm font-medium !w-auto break-words">{node.name}</ItemTitle>
            <div className="flex items-center gap-2">
              <ItemContent className="text-xs text-muted-foreground shrink-0">{node.type}</ItemContent>
              <NavLink to={`/knowledge/${node.id}`} className="text-xs text-primary hover:underline shrink-0">
                {t('goToNode')}
              </NavLink>
            </div>
          </div>
          {!readonly && (
            <IconButton
              variant="ghost"
              size="icon"
              onClick={() => onRemove(node.id)}
              label={t('removeFromSet')}
              icon={<TrashIcon className="size-4" />}
            />
          )}
        </ItemHeader>
      </Item>
    </li>
  );
};
